import { KeyboardEvent } from 'react';

export const ignoreKeys = (e, listener?: (e: KeyboardEvent) => any) => {
  if (e.key === ' ' || e.key === 'Backspace') {
    e.nativeEvent.stopImmediatePropagation();
    e.nativeEvent.stopPropagation();
  } else {
    listener?.(e);
  }
};
